import { render } from "./Incentives.view.vue?vue&type=template&id=2202b8d8"
import script from "./Incentives.view.vue?vue&type=script&lang=js"
export * from "./Incentives.view.vue?vue&type=script&lang=js"

import "./Incentives.view.vue?vue&type=style&index=0&id=2202b8d8&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__